<div class="flex justify-end text-accent text-lg">
  <div class="pr-2">Tài khoản Coin hiện tại: <span class="font-bold">{{currentCoin | number: '1.0-0'}}</span></div>
  <img src="{{srcCoin}}" alt="Current Coin" class="h-5 -mt-0.5" />
</div>